import { FieldProps, AgentInputFieldSchema } from 'common/form/types/Form';
import { FieldWrapper } from './FieldWrapper';
import { AgentInput as AgentInputComponent } from 'components/Inputs';

export const AgentInput: React.FC<FieldProps<AgentInputFieldSchema>> = ({
  name,
  value,
  field,
  errorMessage,
  onChange
}) => {
  const { label, subLabel } = field;

  return (
    <FieldWrapper label={label} subLabel={subLabel} errorMessage={errorMessage}>
      <AgentInputComponent
        name={name}
        value={value?.name}
        onChange={(e) =>
          onChange({
            name: e.target.value,
            agentId: value?.id
          })
        }
        onOptionClick={({ value }) => {
          onChange({
            name: value.name,
            agentId: value.id
          });
        }}
        id={name}
        data-testid={name}
      />
    </FieldWrapper>
  );
};
